import Vue from 'vue';

const state = {
  dashboards: {},
  lastVisitedId: [],
};

const getters = {
  // Default dashboard
  dashboard: (state, getters) => {
    return getters['menuDefaultDashboard'];
  },
  get: (state) => state.dashboards,
  lastVisitedId: (state) => [...state.lastVisitedId],
  list: (state) => Object.keys(state.dashboards).map(id => state.dashboards[id]),
  menuDashboards: (state, getters, rootState, rootGetters) => {
    const destinations = ['dashboard', 'dashboard_group'];
    let menuItems = rootGetters['navigationItems/menuItems'];
    menuItems = menuItems.filter( menuItem => destinations.includes(menuItem.destination) );
    menuItems = menuItems.sort( (a, b) => { return a.order > b.order; } );
    return menuItems;
  },
  menuDefaultDashboard: (state, getters, rootState, rootGetters) => {
    let menuItems = rootGetters['navigationItems/menuItems'];
    let menuItem = menuItems.find(menuItem => menuItem.destination == 'dashboard');
    if (menuItem) {
      return rootGetters['dashboards/get'][menuItem.resourceId];
    }
  },
};

const mutations = {
  set: function(state, dashboards) {
    dashboards.forEach(dash => {
      Vue.set(state.dashboards, dash.id, dash);
    });
  },
  setLastVisitedId: function(state, id) {
    state.lastVisitedId = [...id];
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
};
